var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" This is the home page, it is the default page when you visit the site. It's empty right now, but we will add some content here soon. ")])}
var staticRenderFns = []

export { render, staticRenderFns }